<template>
  <UiSectionWrapper
    title="Optimalkan Cashflow, Percepat Pertumbuhan!"
    sub-title="COD Advance"
    description="Dengan COD Advance, dana COD bisa diakses lebih awal untuk mendukung kelancaran operasional dan ekspansi brand Anda."
    hero-image="/images/cod-advance-banner-4.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
  >
    <template #action>
      <div
        class="flex flex-col sm:items-center sm:flex-row gap-2 lg:gap-4 py-2"
      >
        <UiButton
          :to="
            $utm.utmUrl('/login', {
              redirectTo: '/cod-advance'
            })
          "
          label="Ajukan COD Advance"
        />
        <UiButton
          :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
          label="Konsultasi dengan Tim Kami"
          variant="primaryOutline"
        />
      </div>
    </template>
  </UiSectionWrapper>
</template>
